import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import BundleVariantConfigContent from "./product-bundle-configuration-content.jsx";
import storefront from "../../helpers/storefront";
import * as queries from "../../helpers/storefront/queries";

const BundleConfigContent = ({ data, form, group, bundle, parent = null }) => {
  // const [bundleProducts, setBundleProducts] = useState(bundle);
  console.log(`bundle`, bundle);
  const bundleProducts = bundle;
  const [showIndex, setShowIndex] = useState(4);
  const buttonRef = useRef(null);

  const handleShowMore = () => {
    setShowIndex(showIndex + 5);
    if (buttonRef) {
      const form = buttonRef.current.closest(".product-main__form");
      setTimeout(() => {
        form.scrollBy({ top: 200, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <>
      <div className={`bundle-config__wrapper`}>
        {bundleProducts?.map((product, index) => {
          if (index > showIndex) {
            return null;
          }

          return (
            <BundleVariantConfigContent
              data={data}
              product={product}
              form={form}
              group={group}
            />
          );
        })}
      </div>
      {showIndex < bundleProducts.length - 1 && (
        <button
          type="button"
          className="bundle-config__show-more"
          onClick={handleShowMore}
          ref={buttonRef}
        >
          View More
        </button>
      )}
    </>
  );
};

export default BundleConfigContent;
